// @ vendors
const get = require('lodash/object/get');
// @ commons
const { APIGet } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const actionTypes = require('constants/actionTypes');

const requestMovementsInProgress = () => ({
    type: actionTypes.FETCH_MOVEMENTS_REQUEST
});

const requestMovementsSuccess = (response) => ({
    type: actionTypes.FETCH_MOVEMENTS_SUCCESS,
    payload: {
        movementsList: get(response, 'listadoMovimientos.lista', []),
    }
});

const requestMovementsFailure = (error) => ({
    type: actionTypes.FETCH_MOVEMENTS_FAILURE,
    payload : {
        error
    }
});

const validNGOCardSuccess = (hasNGOs) => ({
    type: actionTypes.VALID_NGO_CARD_SUCCESS,
    payload: {
        hasNGOs
    }
})

const validNGOCardFailure = () => ({
    type: actionTypes.VALID_NGO_CARD_FAIL,
})

const requestMovements = (depositId, impositionId) => (dispatch, getState) => {
    const isAlreadyFetching = getState().deposits.get('isFetching');
    const immDeposit = getState().deposits.getIn(['byId', depositId]);
    const immImposition = immDeposit.getIn(['impositionList','byId', impositionId]);
    const subContractNumber = immImposition.get('id');
    const fromDate = immImposition.get('activationDate');
    const toDate = immImposition.get('expirationDate');

    if (!isAlreadyFetching) {
            const requestData = {
                query: {
                    producto: immDeposit.getIn(['contract', 'product']),
                    numeroContrato: immDeposit.getIn(['contract', 'contractNumber']),
                    idscontr: subContractNumber,
                    codmonje: immImposition.get('currency'),
                    impmax: 0,
                    impmin: 0,
                    fechaDesde: fromDate,
                    fechaHasta: toDate
                }
            };

            dispatch(requestMovementsInProgress());

            return APIGet(dispatch, apiURLBuilder.getURL('movements'), requestData).then(
                response => dispatch(requestMovementsSuccess(response)),
                error => dispatch(requestMovementsFailure(error))
            );
    }
};

const validNGOCard = (card) => (dispatch) => {
    const data = card.getIn(['contract', 'number']).replace(/\s/g, '');
    const url = apiURLBuilder.getURL('cardsSolidarityData', { data })

    return APIGet(dispatch, url)
        .then((response) => {
                dispatch(validNGOCardSuccess(response.ngos || response.ngos.length > 0))
            }, () => {
                dispatch(validNGOCardFailure());
            }
        );
};

module.exports = {
    requestMovements,
    validNGOCard
};
